import { Category } from './category';

export enum OrderType {
  Retirada = 'retirada',
  Entrega = 'entrega',
}

export type ProductCart = {
  name: string;
  price: number;
  category: Category;
  description: string;
  quantity: number;
  countable: boolean;
};
